
import '../../main.css'
import './ServiceCard.css'
import './MServiceCard.css'
import { lP, oP } from '../../main.js'


export default function ServiceCard(props) {
    return (
        <div className={'servicecard noselect ' + props.className} onClick={() => props.onclick()}>
            <img src={props.iconimg} alt={"Service-Icon mit dem jeweiligen Symbol für die angebotene Leistung"} />
            <font>{props.title}</font>
        </div>
    )
}